import React, { Component } from 'react';
import { Modal, Select, Button, message, Tooltip, Input } from 'antd';
import { msgNotice, cancelCollect, getEditPatientExamInfo, remoteHospitalList } from '@/request/api'
import { requestErrorLog } from "@/common/util";
import './styles/apply.scss';
import moment from "moment";
import { sendMessage, receiveMessage } from '@/request/websocket';

const { Option } = Select;
const { TextArea } = Input;

class ApplyConsulation extends Component {
  state = {
    checkedHospitalCode: '',
    checkedHospital: '',
    applyConst: 0,
    PATIENT_SYMPTOM: '',
    EXAM_SUGGEST: '',
    consulationList: []
  }

  componentDidMount() {
    this.initApplyHospCode()
    if (this.props.applyType === 'ConsultationEDIT') {
      this.props.onConsultationRef(this)
    }
    if (this.props.applyType === 'ApplyADD') {
      this.props.onApplyConsultRef(this)
    }
    if (this.props.rowData.length > 0) {
      this.setState({
        PATIENT_SYMPTOM: this.props.rowData[0].PATIENT_SYMPTOM ?? '',
        EXAM_SUGGEST: this.props.rowData[0].EXAM_SUGGEST ?? ''
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.visible !== prevProps.visible) {
      this.initApplyHospCode()
    }
  }

  async initApplyHospCode() { //根据申请医院获取会诊医院
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    let params = {
      Type: "Remote",
      hospital_Code: userInfo.HOSPITAL_CODE
    }
    let res = await remoteHospitalList(params)
    if (res && res.Status === 1) {
      const applyData = res.Result
      // 过滤当前登录医院及已停用的医院
      let consulationList = applyData.filter(item => item.CONSULTATION_HOSPITAL_CODE !== userInfo.HOSPITAL_CODE && item.IS_ENABLED === 1)
      this.setState({
        consulationList
      })
      return consulationList
    } else {
      requestErrorLog('', '根据申请医院获取会诊医院接口报错', 0, true)
    }
  }

  handleChangeConsulationHospital = (value) => {
    const { consulationList } = this.state
    this.setState({
      checkedHospital: value
    });
    for (let i in consulationList) {
      if (value === consulationList[i].CONSULTATION_HOSPITAL_NAME) {
        this.setState({
          checkedHospitalCode: consulationList[i].CONSULTATION_HOSPITAL_CODE
        })
      }
    }
  }

  handleTransferStatus = async (value) => {  // websocket 申请会诊(本院)
    const { checkedHospitalCode, checkedHospital, PATIENT_SYMPTOM } = this.state
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    const settingValues = JSON.parse(localStorage.getItem("settingValues"));
    //拿到可以申请会诊的医院数据
    let consulationList = await this.initApplyHospCode()
    let result = consulationList.find(item => item.CONSULTATION_HOSPITAL_CODE === settingValues.automaticConsult)
    let examId = [];
    let name = [];
    this.props.rowData.forEach((item) => {
      examId.push(item.EXAM_UID)
      name.push(item.NAME)
    })
    const wsData = {
      TYPE: 'HOLTER',
      PARAM: 'APPLY_CONSULATION',   //参考PARAM参数说明
      NAME: name.length > 0 ? name.toString() : value.NAME,
      SERVER: window.g.baseURL,     // 可配置的服务器地址
      UID_LIST: examId.length > 0 ? examId : [value.EXAM_UID],             //病人数据ID集合
      USER_INFO: userInfo,          //登录人的用户信息
      CONSULTATION_HOSPITAL_CODE: checkedHospitalCode || result.CONSULTATION_HOSPITAL_CODE, // 会诊医院code
      CONSULTATION_HOSPITAL_NAME: checkedHospital || result.CONSULTATION_HOSPITAL_NAME,      // 会诊医院name
      PATIENT_SYMPTOM: examId.length === 1 ? PATIENT_SYMPTOM : '', //患者症状
      EXAM_SUGGEST: this.state.EXAM_SUGGEST ?? '', //诊疗建议 注：申请会诊后台不接收该字段，正常传防止中间件报错
    };
    console.log(JSON.stringify(wsData), 'HOLTER发送的数据..')
    sendMessage(wsData)
    this.handleCloseApplyModal();
    receiveMessage(received_msg => {
      console.log(received_msg, '接收到的数据..')
      if (received_msg) {
        this.props.setTransferStatus(received_msg)
      }
      if (received_msg.RETURN_MSG === "上传成功") {
        message.success("申请会诊成功！");
        this.handleEditPatientExamInfo(received_msg.EXAM_UID)
        this.props.refreshTable()
      }
    })
  }

  handleApplyConsult = async (value) => {
    const { rowData, applyType, showKey } = this.props;
    const { checkedHospitalCode, checkedHospital } = this.state;
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    const { automaticApply = [], automaticConsult = null } = JSON.parse(localStorage.getItem("settingValues")) || {};

    // 获取可申请会诊的医院
    let consulationList = await this.initApplyHospCode();

    // 校验和处理
    if (value === 'clickApply') {
      const warningMessage = this.validateCheckedHospital(checkedHospital, checkedHospitalCode, consulationList);
      if (warningMessage) return message.warning(warningMessage);
    } else {
      console.log(value, 'value');
      const warningMessage = this.validateAutomaticApply(automaticApply, automaticConsult, value.TYPE);
      if (warningMessage) return message.warning(warningMessage);
    }

    // 查找自动申请医院
    let autoConsultObj = consulationList.find(item => item.CONSULTATION_HOSPITAL_CODE === automaticConsult) || {};
    if (value !== 'clickApply' && Object.keys(autoConsultObj).length === 0) return;

    let params = {
      Type: applyType,
      hospital_Code: userInfo.HOSPITAL_CODE,
      hospital_Name: userInfo.HOSPITAL_NAME
    };
    const emptyObj = {};
    const list = rowData.length > 0 ? rowData : [emptyObj];

    const patientList = list.map(item => ({
      EXAM_UID: item.EXAM_UID || value.EXAM_UID,
      NAME: item.NAME || value.NAME,
      // 20250313修改 申请会诊医院、申请会诊医生取当前登录人(后台取消会诊会保留上一次操作)
      // APPLY_DOCTOR_CODE: item.APPLY_DOCTOR_CODE || userInfo.USER_UID,
      // APPLY_DOCTOR_NAME: item.APPLY_DOCTOR_NAME || userInfo.REAL_NAME,
      // APPLY_HOSPITAL_CODE: item.APPLY_HOSPITAL_CODE || userInfo.HOSPITAL_CODE,
      // APPLY_HOSPITAL_NAME: item.APPLY_HOSPITAL_NAME || userInfo.HOSPITAL_NAME,
      APPLY_HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
      APPLY_HOSPITAL_NAME: userInfo.HOSPITAL_NAME,
      APPLY_DOCTOR_CODE: userInfo.USER_UID,
      APPLY_DOCTOR_NAME: userInfo.REAL_NAME,
      CONSULTATION_HOSPITAL_CODE: this.state.checkedHospitalCode || autoConsultObj.CONSULTATION_HOSPITAL_CODE,
      CONSULTATION_HOSPITAL_NAME: this.state.checkedHospital || autoConsultObj.CONSULTATION_HOSPITAL_NAME,
      CONSULTATION_STATUS: "1",
      APPLY_DATETIME: moment(new Date()).format("YYYY-MM-DD HH:mm")
    }));

    // 执行会诊申请
    if (applyType === 'ConsultationEDIT' || parseInt(showKey) === 1 || parseInt(showKey) === 3) {
      cancelCollect(params, patientList).then(res => {
        if (res && res.Status === 1) {
          this.sendMessage(patientList, autoConsultObj);
          message.success("申请会诊成功！");
          if (rowData.length > 0) {
            this.handleEditPatientExamInfo(rowData[0].EXAM_UID);
          }
          this.props.refreshTable();
          this.handleCloseApplyModal();
        } else {
          message.error("申请会诊失败！");
          requestErrorLog(rowData.EXAM_UID, '申请会诊接口报错', 0, true);
          this.props.refreshTable();
          this.handleCloseApplyModal();
        }
      });
    } else {
      this.handleTransferStatus(value);
    }
  }

  // 验证选中的会诊医院
  validateCheckedHospital = (checkedHospital, checkedHospitalCode, consulationList) => {
    if (!checkedHospital) return "请选择会诊医院！";
    let checkedConsultObj = consulationList.find(item => item.CONSULTATION_HOSPITAL_CODE === checkedHospitalCode) || {};
    if (Object.keys(checkedConsultObj).length === 0) {
      this.setState({
        checkedHospitalCode: '',
        checkedHospital: ''
      });
      return "请选择有效会诊医院！";
    }
    return null;
  }

  // 验证自动申请条件
  validateAutomaticApply = (automaticApply, automaticConsult, type) => {
    const warningMessage = "未找到关联会诊机构，请重新配置";
    if (automaticApply.length === 0 && !automaticConsult) return null;
    if (!automaticConsult || (!Array.isArray(automaticApply) || !automaticApply.includes(type))) {
      return warningMessage;
    }
    return null;
  }

  // 发送消息通知
  sendMessage = (patientList, autoConsultObj) => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    const RequestModel = patientList.map(item => ({
      MSG_CODE: '3',
      MSG_DETAILED: `有【${localStorage.getItem('loginHospitalName')}】的患者【${item.NAME}】需要会诊！`,
      EVENT_ID: item.EXAM_UID,
      HOSPITAL_CODE: this.state.checkedHospitalCode || autoConsultObj.CONSULTATION_HOSPITAL_CODE,
      USER_UID: userInfo.USER_UID,
    }));

    let Params = {
      Type: "MsgNotice",
      HOSPITAL_CODE: userInfo.HOSPITAL_CODE
    };
    this.messageInform(Params, RequestModel);
  }

  handleComplete = () => { //完成会诊
    if (this.props.completeConsultation === 'blood') {
      this.props.bloodFinished(this.props.rowData[0])
    } else {
      this.props.finishedComplete(
        this.props.rowData[0],
        this.state.PATIENT_SYMPTOM,
        this.state.EXAM_SUGGEST
      )
    }
    this.handleCloseApplyModal();
  }

  handleEditPatientExamInfo = async (val) => {
    let params = {
      Type: "EditPatientExamInfo",
      EXAM_UID: val,//检查uid
      PATIENT_SYMPTOM: this.state.PATIENT_SYMPTOM ?? '',//患者症状
      EXAM_SUGGEST: this.state.EXAM_SUGGEST ?? ''//诊疗建议
    }
    let res = await getEditPatientExamInfo(params)
    if (res && res.Status !== 1) {
      requestErrorLog(val, '患者症状/诊疗建议接口报错', 0, true)
    }
  }

  changeTextArea = (e) => {
    this.setState({
      PATIENT_SYMPTOM: e.target.value
    })
  }

  changeInspectTextArea = (e) => {
    this.setState({
      EXAM_SUGGEST: e.target.value
    })
  }

  handleCloseApplyModal = () => {
    this.props.onRef(false)
  }

  //申请会诊消息通知
  messageInform = async (Params, RequestModel) => {
    let res = await msgNotice(Params, RequestModel);
    if (res && res.Status !== 1) {
      requestErrorLog('', '申请会诊消息通知接口报错', 0, true)
    }
  }

  render() {
    const { visible, rowData, applyConsulationType } = this.props;
    const { consulationList } = this.state
    return (
      <Modal
        className="consulationH"
        width={460}
        title={applyConsulationType === 'apply' ? '选择会诊医院' : '完成会诊'}
        visible={visible}
        footer={[
          applyConsulationType === 'apply' ?
            <Button key="save" type="primary" onClick={() => this.handleApplyConsult('clickApply')}>申请</Button>
            : <Button key="save" type="primary" onClick={this.handleComplete}> 完成会诊</Button>,
          <Button key="exit" type="primary" onClick={this.handleCloseApplyModal}>
            取消
          </Button>
        ]}
        onCancel={this.handleCloseApplyModal}                // 右上角的关闭按钮
      >
        <div className="consulationInfo">
          {rowData.length > 0 ?
            rowData.map((item, index) => {
              return <div key={index} className='applyInfo'>
                <Tooltip title={item.NAME}>姓名：{item.NAME}</Tooltip>
                <Tooltip title={item.SEX_NAME}>性别：{item.SEX_NAME}</Tooltip>
                <Tooltip title={item.PATIENT_ID}>病历号：{item.PATIENT_ID}</Tooltip>
              </div>
            }) : null
          }
          {applyConsulationType === 'apply' ?
            <Select placeholder="请选择会诊医院" onChange={this.handleChangeConsulationHospital} style={{ width: '400px', marginBottom: '20px' }} value={this.state.checkedHospital}>
              {
                consulationList.map((item) => (
                  <Option key={item.CONSULTATION_HOSPITAL_NAME} value={item.CONSULTATION_HOSPITAL_NAME}>{item.CONSULTATION_HOSPITAL_NAME}</Option>
                ))
              }
            </Select> : null
          }
          {rowData.length > 1 ? null :
            <div style={{ padding: '5px' }}>
              <span>患者症状:</span>
              <TextArea
                rows={4}
                maxLength={500}
                style={{ width: '400px', marginTop: '5px' }}
                disabled={applyConsulationType === 'complete'}
                placeholder="请输入患者症状信息"
                value={this.state.PATIENT_SYMPTOM}
                onChange={this.changeTextArea}
              />
            </div>
          }
          {rowData.length <= 1 && applyConsulationType === 'complete' ?
            <div style={{ padding: '5px' }}>
              <span>诊疗建议:</span>
              <TextArea
                rows={4}
                maxLength={500}
                style={{ width: '400px', marginTop: '5px' }}
                placeholder="请输入诊疗建议"
                value={this.state.EXAM_SUGGEST}
                onChange={this.changeInspectTextArea}
              />
            </div> : null
          }
        </div>
      </Modal>
    )
  }
}

export default ApplyConsulation;
